export const YEAR_ITEMS_NUMBER=12;export const getYearsRange=year=>{const rangeEnd=12*Math.ceil(year/12);return{rangeStart:rangeEnd-11,rangeEnd:rangeEnd}};